import { render, staticRenderFns } from "./communicate-detail.vue?vue&type=template&id=df2d31fe&scoped=true"
import script from "./communicate-detail.vue?vue&type=script&lang=ts"
export * from "./communicate-detail.vue?vue&type=script&lang=ts"
import style0 from "./communicate-detail.vue?vue&type=style&index=0&id=df2d31fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2d31fe",
  null
  
)

export default component.exports